module.exports = __webpack_public_path__ + "static/media/Flaticon.15cf01b7.woff";